import * as getUsers from "@/api/users/search";

export default {
	namespaced: true,
	state: {
		users: [],
		filter: null,
		error: null,
		pagination: null,
		totalPages: null,
	},
	getters: {
		readUsers: (state) => state.users,
		readFilter: (state) => state.filter,
		readError: (state) => {
			return state.error;
		},
		readPagination: (state) => state.pagination,
		readTotalPages: (state) => state.totalPages,
	},
	mutations: {
		SET_USERS(state, payload) {
			state.users = payload;
		},
		SET_FILTER(state, payload) {
			state.filter = payload;
		},
		SET_ERROR(state, payload) {
			state.error = payload;
		},
		SET_PAGINATION(state, payload) {
			state.pagination = payload;
		},
		SET_TOTAL_PAGES(state, payload) {
			state.totalPages = payload;
		},
	},
	actions: {
		async getUsers({ commit, getters, rootGetters }) {
			const token = rootGetters["loginStore/readToken"];
			let getUsersRes = await getUsers
				.getUsers(token, getters.readFilter, getters.readPagination)
				.then((data) => {
					if (data) {
						const response = data.items || data;
						Array.isArray(response)
							? commit("SET_USERS", response)
							: commit("SET_USERS", [response]);
						commit("SET_TOTAL_PAGES", data.total);
						return true;
					} else {
						commit("SET_USERS", []);
						commit("SET_TOTAL_PAGES", null);

						return false;
					}
				})
				.catch((error) => {
					if (error.response) {
						let message =
							error.response.data.message ||
							error.response.data.detail[0].msg;
						message == "Token expired"
							? commit("loginStore/SET_ACCESS_TOKEN", null, {
									root: true,
							  })
							: message
							? commit("SET_ERROR", message)
							: commit("SET_ERROR", "Algo salió mal");
					} else {
						console.log(error);
						commit("SET_ERROR", error);
					}
				});
			return getUsersRes;
		},
	},
};
